import { z } from "zod";

export const ApproveDocumentDispatchRequestValidation = z.object({
  queue_entry_id: z.string().uuid(),
}).strict();

export const HideDocumentDispatchRequestValidation = z.object({
  queue_entry_id: z.string().uuid(),
  reason: z.string().trim().min(1, "A reason is required"),
}).strict();

export const RetryDocumentDispatchRequestValidation = z.object({
  queue_entry_id: z.string().uuid(),
}).strict();

export const SendDocumentDispatchRequestValidation = z.object({
  queue_entry_id: z.string().uuid(),
  is_test_send: z.boolean(),
}).strict();

export const HideOtcContractDocumentInstanceRequestValidation = z.object({
  instance_id: z.string().uuid(),
  reason: z.string().trim().min(1, "A reason is required"),
}).strict();

export const HideAgtechContractDocumentInstanceRequestValidation = z.object({
  instance_id: z.string().uuid(),
  reason: z.string().trim().min(1, "A reason is required"),
}).strict();

export type ApproveDocumentDispatchRequest = z.infer<typeof ApproveDocumentDispatchRequestValidation>;
export type HideDocumentDispatchRequest = z.infer<typeof HideDocumentDispatchRequestValidation>;
export type RetryDocumentDispatchRequest = z.infer<typeof RetryDocumentDispatchRequestValidation>;
export type SendDocumentDispatchRequest = z.infer<typeof SendDocumentDispatchRequestValidation>;
export type HideOtcContractDocumentInstanceRequest = z.infer<typeof HideOtcContractDocumentInstanceRequestValidation>;
export type HideAgtechContractDocumentInstanceRequest = z.infer<typeof HideAgtechContractDocumentInstanceRequestValidation>;
